import { openProposalMail } from "@/features/portfolio-analysis/lib/proposal-mail-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PrepareProposalMailArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  awaitingResult,
  choiceResult,
  searchedInstead,
} from "@/features/intelligence/lib/tool-result";

export async function prepareProposalMail(
  { seed, ignored, notAnId }: PrepareProposalMailArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openProposalMail(toolCallId, seed);
  const choice = await cardChoice(seed, false);
  if (choice.kind !== "chosen") {
    return choiceResult(
      choice,
      searchedInstead(
        `A proposal-mail card is in the chat. Once the client is chosen, it ${FINDS}. ${UNSENT}`,
        seed,
        notAnId,
      ),
      KEEP_OUT,
      ignored,
    );
  }
  return awaitingResult(
    searchedInstead(`A proposal-mail card is shown in the chat. It ${FINDS}`, seed, notAnId),
    UNSENT,
    `points to the card; ${KEEP_OUT}`,
    ignored,
  );
}

const FINDS =
  "finds the client's latest portfolio proposal itself, and none of it reaches you: it asks " +
  "the advisor which one when the latest are in several portfolios, and says so when the " +
  "client has none, in which case a new one is prepare_portfolio_proposal";

const UNSENT =
  "Nothing has been sent: the advisor opens the mail in their own mail program with Mejla " +
  "kunden and sends it from there, and the app keeps no record of it";

const KEEP_OUT =
  "do not describe the proposal, its files or the mail, and do not say anything was sent";
